import { createFileRoute } from '@tanstack/react-router';
import { FamilyTree } from '@/pet/src/components/FamilyTree';
import { NoPetsEmptyState } from '@/pet/src/components/NoPetsEmptyState';
import { usePets } from '@/pet/src/context/PetsContext';

export const Route = createFileRoute('/dashboard/family')({
  component: PetsoFamily,
});

function PetsoFamily() {
  const { selectedPet, isLoading } = usePets();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!selectedPet) {
    return <NoPetsEmptyState />;
  }

  return <FamilyTree pet={selectedPet} />;
}


